// min stepper height in rem units
export const STEPPER_MIN_HEIGHT = 75;
